import type { IconData } from '@stacksjs/iconify-core'

export const pa4x3: IconData = {
  "body": "<defs><clipPath id=\"SVG9mrxwcPk\"><path fill-opacity=\".7\" d=\"M0 0h640v480H0z\"/></clipPath></defs><g clip-path=\"url(#SVG9mrxwcPk)\"><path fill=\"#fff\" d=\"M0 0h640v480H0z\"/><path fill=\"#fff\" fill-rule=\"evenodd\" d=\"M92.5 0h477.2v480H92.4z\"/><path fill=\"#db0000\" fill-rule=\"evenodd\" d=\"M323 3.6h358v221.7H323z\"/><path fill=\"#0000ab\" fill-rule=\"evenodd\" d=\"M3.2 225.3h319.9V480H3.2zm211.6-47.6l-42-29.4l-41.7 29.6l15.5-48L105 100l51.6-.4l16-48l16.3 47.9h51.6l-41.5 30l15.9 48z\"/><path fill=\"#d80000\" fill-rule=\"evenodd\" d=\"m516.9 413.9l-42.4-27.7l-42.1 28l15.6-45.6l-42-28l52-.5l16.2-45.4l16.4 45.3h52l-41.8 28.5l16 45.4z\"/></g>",
  "width": 640,
  "height": 480,
  "viewBox": "0 0 640 480"
}

export default pa4x3
